import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const LoadingDots = () => {
  const { t, i18n } = useTranslation();

  const [dots, setDots] = useState(1);
  const colors = [
    "red",
    "green",
    "blue",
    "pink",
    "red",
    "gray",
    "orange",
    "red",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prevDots) => (prevDots < 7 ? prevDots + 1 : 1));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const styles = {
    overlay: {
      position: "fixed", // Cover the entire screen
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent grey background
      zIndex: 9999, // Ensure it's above all other elements
      display: "flex", // Flexbox for centering
      alignItems: "center", // Vertical centering
      justifyContent: "center", // Horizontal centering
    },
    loader: {
      zIndex: 10000, // Keep the loader above the background
    },
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.loader}>
        <h1 style={{ fontWeight: "bold", color: colors[dots] }}>
          {t("Loading")}
          {".".repeat(dots)}
        </h1>
      </div>
    </div>
  );
};

export default LoadingDots;
